import { Component, computed, input, inject } from '@angular/core';
import { NodeCamp } from '@app/models/entity.model';
import { HeroTextComponent } from '@app/components/hero-text/hero-text.component';
import { ParagraphLoaderComponent } from '@app/entities/paragraph/loader.component';

import { MediaComponent } from '@app/components/media/media.component';
import { HeroVImagesComponent } from '@app/components/hero-v-images/hero-v-images.component';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { ContentLinkService } from '@app/services/contentLinks.service';

@Component({
  selector: 'mobi-node-camp',
  templateUrl: './node-camp.component.html',
  styleUrls: ['./node-camp.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    HeroTextComponent,
    MediaComponent,
    HeroVImagesComponent,
    ParagraphLoaderComponent,
  ],
})
export class NodeCampComponent {
  readonly entity = input.required<NodeCamp>();
  #contentLink = inject(ContentLinkService);

  contentLinks = computed(() => {
    const paragraphs = this.entity()?.paragraphs;
    return this.#contentLink.getContentLinks(paragraphs);
  });

  is5Image = computed(() => this.entity()?.images5?.length);

  is3Image = computed(
    () => !this.entity()?.images5?.length && this.entity()?.images3?.length
  );

  isLeftImage = computed(
    () =>
      !this.entity()?.images5?.length &&
      !this.entity()?.images3?.length &&
      this.entity()?.imageLeft
  );

  isRightImage = computed(
    () =>
      !this.entity()?.images5?.length &&
      !this.entity()?.images3?.length &&
      !this.entity()?.imageLeft &&
      this.entity()?.imageRight
  );

  isVideo = computed(
    () =>
      !this.entity()?.images5?.length &&
      !this.entity()?.images3?.length &&
      !this.entity()?.imageLeft &&
      !this.entity()?.imageRight &&
      this.entity()?.video
  );

  isFullWidthImage = computed(
    () =>
      !this.entity()?.images5?.length &&
      !this.entity()?.images3?.length &&
      !this.entity()?.imageLeft &&
      !this.entity()?.imageRight &&
      !this.entity()?.video
  );
}
